import { types } from "mobx-state-tree";
import { api, v3EndpointCommon } from "../api";
import { flow } from "mobx";
import { $spinner } from "store/spinner";
import axios from "../api/axios";

export const $user = types
  .model("User", {
    profile: types.frozen([]),
    isAuthorized: types.optional(types.boolean, false),
    isAuthChecked: types.optional(types.boolean, false),
    isDeveloper: types.optional(types.boolean, false),
    roles: types.frozen([]),
  })
  .views((self) => ({
    get isCourier() {
      return !!self.roles.find((role) => role.name === "courier");
    },
  }))
  .actions((self) => ({
    login: flow(function* (phone, password) {
      try {
        $spinner.show();
        const JWT = yield api(v3EndpointCommon)
          .post("login", {
            phone,
            password,
          })
          .then((res) => {
            if (!res?.data?.access_token) {
              throw new Error("Login response does not contain access token");
            }

            return res.data.access_token;
          });
        localStorage.setItem("jwtToken", JWT);
        const { initRequests } = yield import("../init");
        yield initRequests({ throwOnError: true });
      } catch (err) {
        console.error("auth user error: ", err);
        self.resetAuth();
        throw err;
      } finally {
        $spinner.hide();
      }
    }),
    setProfile(profile) {
      self.profile = profile;
    },
    setIsAuthorized(value) {
      self.isAuthorized = value;
    },
    setIsAuthChecked(value) {
      self.isAuthChecked = value;
    },
    logout() {
      return new Promise((resolve) => {
        self.resetAuth();
        resolve();
      });
    },
    resetAuth() {
      localStorage.removeItem("jwtToken");
      delete axios?.defaults?.headers?.common?.Authorization;
      delete axios?.defaults?.headers?.common?.JWT;
      self.isAuthorized = false;
      self.isAuthChecked = true;
      self.isDeveloper = false;
      self.profile = [];
      self.roles = [];
    },
    setIsDeveloper(value) {
      self.isDeveloper = value;
    },
    setRoles(value) {
      self.roles = value;
    },
  }))
  .create();
